/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { object, string } from 'prop-types';
import ReactHTMLParser from 'react-html-parser';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import { useUIDSeed } from 'react-uid';
import { connect, useSelector } from 'react-redux';
import { compose } from 'recompose';
import { getSSRDeviceType } from '../../../../state/ducks/App/App-Selectors';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';
import data from './ViewData';
import { getPresentationFamily } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';

const styles = (theme)  => ({
    container: {
        maxWidth: 980,
        width: '100%',
        margin: 'auto',
    },
    header: {
        textAlign: 'center',
        '& h1': {
            fontWeight: 100,
        },
        [theme.breakpoints.down('sm')]: {
            padding: '0px 10px',
            '& p': {
                fontSize: 14,
            },
            '& h1': {
                fontSize: 28,
            },
        },
    },
    tableMainContainer: {
        margin: '0 auto',
        '& table': {
            width: '100%',
            textAlign: 'center',
        },
        '& table, td': {
            border: `1px solid ${theme.palette.cms?.black || '#000000'}`,
            borderCollapse: 'collapse',
            fontSize: 14,
            fontWeight: 600,
            padding: '8px 0',
        },
        '& th': {
            background: theme.palette.cms?.black || '#000000',
            color: theme.palette.cms?.white || '#ffffff',
            fontSize: 16,
            padding: 5,
            border: `1px solid ${theme.palette.cms?.black || '#000000'}`,
            borderCollapse: 'collapse',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '0px 10px',
        },
    },
    subTitle: {
        display: 'block',
        fontWeight: 100,
    },
    mapGrid: {
        width: '100%',
        minHeight: 400,
        top: '-55px',
        position: 'relative',
    },
    mapHeading: {
        textAlign: 'center',
        fontWeight: 600,
        '& p': {
            margin: 0,
            paddingBottom: '2em',
        },
        [theme.breakpoints.down('sm')]: {
            '& p': {
                fontSize: 14,
            },
        },
    },
    mapContainer: {
        overflow: 'hidden',
    },
    backBtn: {
        padding: '10px 5px 10px',
        margin: 'auto',
        maxWidth: 1400,
        borderTop: `1px solid ${theme.palette.cms?.black || '#000000'}`,
        marginTop: 25,
        fontSize: 14,
        '& a': {
            color: theme.palette.cms?.black || '#000000',
            fontWeight: 600,
        },
    },
    bannerImage: {
        maxWidth: '980px',
        [theme.breakpoints.down('md')]: {
            maxWidth: '600px',
        },
        [theme.breakpoints.down('xs')]: {
            maxWidth: '380px',
        },
    },
});

const KristinaLibbyMapLandingPage = ({ classes, ssrDeviceType }) => {
    const seed = useUIDSeed();
    const seo = {
        page_title: 'Floral Heart Project Locations | 1800Flowers ',
        keywords: '',
        meta_description: 'Find the closest Floral Heart Project close to you by using this interactive map! ',
        location: { pathname: '/floral-heart-project-locations' },
    };
    const presentationFamily = useSelector(getPresentationFamily);
    return (
        <>
            <GraphqlSeoHeadTags seoData={seo} />
            <div className={classes.backBtn}><Link to={data.back_button.link}>{ReactHTMLParser(data.back_button.title)}</Link> </div>
            <div className={classes.container}>
                <Grid container>
                    <Grid item xs={12}>
                        <div className={classes.header}>
                            <h1>{ReactHTMLParser(data.header.title)}</h1>
                            <p>{data.header.description}</p>
                        </div>
                    </Grid>
                    <Grid item xs={12} className={classes.mapHeading}>
                        <p>{data.map_title}</p>
                        {presentationFamily === 'flower' ? (
                            <img src={data.banner_image.path} alt={data.banner_image.alt} className={classes.bannerImage} />
                        ) : (
                            <div className={classes.mapContainer}>
                                <iframe frameBorder="0" className={classes.mapGrid} title="Map" src={data.map_url} />
                            </div>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <div className={classes.tableMainContainer}>
                            <table>
                                <tr>
                                    <th>STATE</th>
                                    <th>CITY</th>
                                    <th>LOCATION</th>
                                </tr>
                                {data.table.map((row) => (
                                    <tr key={seed(row)}>
                                        <td>{ssrDeviceType === 'mobile' ? row.mobile_state_name : row.state}</td>
                                        <td>{row.city}</td>
                                        <td><strong>{row.location.title}</strong><span className={classes.subTitle}>{row.location.sub_title}</span></td>
                                    </tr>
                                ))}
                            </table>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </>
    );
};
const mapStateToProps = (state) => ({
    ssrDeviceType: getSSRDeviceType(state),
});

KristinaLibbyMapLandingPage.propTypes = {
    classes: object.isRequired,
    ssrDeviceType: string.isRequired,
};
const enhance = compose(
    withStyles(styles),
    connect(mapStateToProps, null),
);
export default enhance(KristinaLibbyMapLandingPage);
